"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const SessionContext_1 = require("../context/SessionContext"); // adjust import path as needed
const sessionBuilder_1 = require("../api/sessionBuilder"); // adjust import path
const useHtmltoWord_1 = require("../hooks/useHtmltoWord");
const SessionBuilderContext_1 = require("../context/SessionBuilderContext");
const useHtmlToPpt_1 = require("../hooks/useHtmlToPpt");
// import { useWordToHtml } from "../hooks/useWordTOHtml";
const useHtmlToPdf_1 = require("../hooks/useHtmlToPdf");
const Vaarta_1 = __importDefault(require("./common/icons/Vaarta"));
const SaveAsTemplateModal_1 = __importDefault(require("./SaveAsTemplateModal"));
const Header = ({ getUpdatedSessionValues, newTemplateGenerate = false, }) => {
    const { session, loading, error } = (0, SessionContext_1.useSession)();
    const [templateName, setTemplateName] = (0, react_1.useState)("");
    const [showSaveTemplateModal, setShowSaveTemplateModal] = (0, react_1.useState)(false);
    const { handleDownload } = (0, useHtmltoWord_1.useHtmlToWord)();
    const { handleDownload: handleppt } = (0, useHtmlToPpt_1.useHtmlToPpt)();
    const { handleDownload: handlepdf } = (0, useHtmlToPdf_1.useHtmlToPdf)();
    // const { handleUpload: uploadword } = useWordToHtml();
    const { generatedCode, setGeneratedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    (0, react_1.useEffect)(() => {
        if (session === null || session === void 0 ? void 0 : session.name) {
            setTemplateName(session.name);
        }
    }, [session]);
    console.log("session in header", session);
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        console.log("session", session);
        if (!session)
            return;
        try {
            const valuesToUpdate = getUpdatedSessionValues();
            yield (0, sessionBuilder_1.updateSession)(session.id, Object.assign(Object.assign(Object.assign({}, session), { name: templateName }), valuesToUpdate));
            console.log("Session updated successfully");
        }
        catch (err) {
            console.error("Failed to update session:", err);
        }
    });
    const handleExport = () => {
        if (session && generatedCode) {
            if (session.docType === "word") {
                handleDownload(generatedCode, `${session.name || "export"}.docx`);
            }
            if (session.docType === "ppt") {
                handleppt(generatedCode, `${session.name || "export"}.pptx`);
            }
            if (session.docType === "pdf") {
                handlepdf(generatedCode, `${session.name || "export"}.pdf`);
            }
        }
    };
    const handleSaveAsTemplate = () => {
        setShowSaveTemplateModal(true);
    };
    // const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    //   if (!e.target.files?.[0]) return;
    //   const file = e.target.files[0]; // real file chosen by user\
    //   console.log(file);
    //   const html = await uploadword(file);
    //   console.log(html);
    //   setGeneratedCode(html);
    // };
    // Implement your upload logic here
    const heading = `${session === null || session === void 0 ? void 0 : session.docType} Builder`;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eee", flexWrap: "wrap", p: 2, gap: 2, children: [(0, jsx_runtime_1.jsx)(Vaarta_1.default, {}), (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", gap: 1, alignItems: "center", flex: 1, justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { placeholder: "Template name", variant: "outlined", size: "small", fullWidth: true, value: templateName, onChange: (e) => setTemplateName(e.target.value), disabled: loading, style: { maxWidth: "300px" }, InputProps: {
                            sx: {
                                borderRadius: "8px",
                                backgroundColor: "#f5f5f5",
                                "& fieldset": {
                                    border: "none",
                                },
                            },
                        } }), (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", flexDirection: "row", gap: 1, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", color: "primary", size: "small", onClick: () => {
                                    newTemplateGenerate ? handleSaveAsTemplate() : handleSave();
                                }, disabled: loading, sx: {
                                    fontWeight: "normal",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                }, children: "Save" }), !newTemplateGenerate && ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", color: "secondary", size: "small", onClick: handleSaveAsTemplate, disabled: loading || !generatedCode, sx: {
                                    fontWeight: "normal",
                                    color: "#fff",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                }, children: "Save as Template" })), (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", color: "success", size: "small", onClick: handleExport, sx: {
                                    fontWeight: "normal",
                                    color: "#fff",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                }, children: "Export" })] })] }), (0, jsx_runtime_1.jsx)(SaveAsTemplateModal_1.default, { open: showSaveTemplateModal, onClose: () => setShowSaveTemplateModal(false), htmlContent: generatedCode, docType: session === null || session === void 0 ? void 0 : session.docType, defaultName: templateName })] }));
};
exports.default = Header;
